import { Box, Typography, Skeleton } from '@mui/material';
import { BaseButton } from 'components/BaseButton';
import { OptionButton } from 'components/OptionButton';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';

import { useMortgagesContext } from '../services/context';
import { useStyles } from './header-payoffs-styles';
import AddMortgageModal from './mortgage-detail/components/add-mortgage-modal/add-mortgage-modal';

const HeaderPayoffs: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { path, url } = useRouteMatch();
  const history = useHistory();
  const [addMortgage, setOpenAddMortgage] = useState(false);
  // The header renders outside the `:mortgageId` route, so read the param with an explicit match.
  const mortgageMatch = useRouteMatch<{ mortgageId: string }>(`${path}/mortgage/:mortgageId`);
  const selectedMortgageId = mortgageMatch?.params.mortgageId;
  const { mortgages, loadingMortgages } = useMortgagesContext();

  const handleViewChange = (mortgageId: string) => {
    history.push(`${url.endsWith('/') ? url : url.concat('/')}mortgage/${mortgageId}`);
  };

  return (
    <Box className={classes.headerContainer}>
      <Typography variant="h5" className={classes.title}>
        {t('payoffs:payoffs')}
      </Typography>

      <Box className={classes.pillsRow}>
        <Box className={classes.pillsScroll}>
          {loadingMortgages && mortgages.length === 0 &&
            [1, 2, 3].map((key) => (
              <Skeleton key={key} animation="wave" variant="text" height={42} width={86} />
            ))}
          {mortgages.map((mortgage) => (
            <OptionButton
              key={mortgage._id}
              isSelected={mortgage._id === selectedMortgageId}
              text={mortgage.loan_number ? `${t('payoffs:payoff')} #${mortgage.loan_number}` : `${t('payoffs:loan-unknown')}`}
              onClick={() => {
                handleViewChange(mortgage._id);
              }}
            />
          ))}
        </Box>
        <Box className={classes.addButton}>
          <BaseButton
            buttonVariant="contained"
            buttonColor="secondary"
            text={t('payoffs:add')}
            icon="plus"
            disableElevation
            disabled={loadingMortgages}
            isLoading={loadingMortgages}
            onClick={() => {
              setOpenAddMortgage(true);
            }}
          />
        </Box>
      </Box>
      {addMortgage && (
        <AddMortgageModal
          open={addMortgage}
          onClose={() => {
            setOpenAddMortgage(false);
          }}
        />
      )}
    </Box>
  );
};

export default HeaderPayoffs;
